"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCrossWindowLocalStorage = exports.removeMostRecentPageName = exports.setMostRecentPageName = exports.getMostRecentPageName = exports.removeMostRecentPageLink = exports.setMostRecentPageLink = exports.getMostRecentPageLink = exports.removeCachedReceivedMessages = exports.setCachedReceivedMessages = exports.getCachedReceivedMessages = exports.removeCachedPopOutTimestamp = exports.setCachedPopOutTimestamp = exports.getCachedPopOutTimestamp = exports.removeCachedActiveChatTimestamp = exports.setCachedActiveChatTimestamp = exports.getCachedActiveChatTimestamp = exports.removeCachedSessionId = exports.setCachedSessionId = exports.getCachedSessionId = void 0;
const local_storage_methods_1 = require("./local-storage.methods");
const local_storage_config_1 = __importDefault(require("./local-storage.config"));
// ----------------------------------------
// Session ID
//
// - Used to facilitate session/chat resume when loading
//	 a new window, e.g. with inline chat, or going inline to pop-out.
_a = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.SESSION_ID,
  crossWindow: true
}), exports.getCachedSessionId = _a[0], exports.setCachedSessionId = _a[1], exports.removeCachedSessionId = _a[2];
// ----------------------------------------
// Chat active timestamp
//
// - Used to validate whether the cached session ID is worthy
//	 of a resume attempt, e.g. to avoid resuming a chat session
//	 from days in the past and re-activating the chat launcher.
_b = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.ACTIVE_CHAT_TIMESTAMP,
  crossWindow: true
}), exports.getCachedActiveChatTimestamp = _b[0], exports.setCachedActiveChatTimestamp = _b[1], exports.removeCachedActiveChatTimestamp = _b[2];
// ----------------------------------------
// Pop-out active timestamp
//
// - A consistently-updating timestamp set by the pop-out
//	 window, used by other chat windows to infer whether
//	 there is an active chat pop-out window somewhere.
_c = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.POP_OUT_ACTIVE_TIMESTAMP,
  crossWindow: true
}), exports.getCachedPopOutTimestamp = _c[0], exports.setCachedPopOutTimestamp = _c[1], exports.removeCachedPopOutTimestamp = _c[2];
// ----------------------------------------
// Received message count
//
// - Used prevent an edge-case when resuming a chat session,
//	 wherein the document title "new message" notification
//	 displays the count of all received messages to date.
_d = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.RECEIVED_MESSAGES,
  crossWindow: true
}), exports.getCachedReceivedMessages = _d[0], exports.setCachedReceivedMessages = _d[1], exports.removeCachedReceivedMessages = _d[2];
// ----------------------------------------
// Most recent page name/link
//
// - Used to infer when a user has navigated to a new page
// 	 when resuming the chat, so the agent can be informed.
_e = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.MOST_RECENT_PAGE_LINK,
  crossWindow: true
}), exports.getMostRecentPageLink = _e[0], exports.setMostRecentPageLink = _e[1], exports.removeMostRecentPageLink = _e[2];
_f = (0, local_storage_methods_1.generateGetSetRemove)({
  key: local_storage_config_1.default.CROSS_WINDOW.MOST_RECENT_PAGE_NAME,
  crossWindow: true
}), exports.getMostRecentPageName = _f[0], exports.setMostRecentPageName = _f[1], exports.removeMostRecentPageName = _f[2];
// ----------------------------------------
// Clear cache
/**
 * Clear all cross-window cached values in `localStorage`.
 */
const clearCrossWindowLocalStorage = () => {
  (0, exports.removeCachedSessionId)();
  (0, exports.removeCachedActiveChatTimestamp)();
  (0, exports.removeCachedPopOutTimestamp)();
  (0, exports.removeCachedReceivedMessages)();
  (0, exports.removeMostRecentPageLink)();
  (0, exports.removeMostRecentPageName)();
};
exports.clearCrossWindowLocalStorage = clearCrossWindowLocalStorage;